export const ECOA_BUILDER_FLAGS = {
    EcoaExperimentalTemplates: {
        id: 'EcoaExperimentalTemplates',
        value: false,
        description: 'Enables experimental, in-development screen templates in the eCOA activity builder',
        owner: 'eCOA Builder',
        name: 'Experimental templates',
        extra: { section: 'eCOA Builder' },
    },
};
